// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const LinkedinMd = ({ color = "white", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M8.3335 7.5V15.8333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 7.5V15.8333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.3335 11.1458C8.3335 10.1789 8.72858 9.25157 9.43184 8.56784C10.1351 7.88411 11.0889 7.5 12.0835 7.5C13.0781 7.5 14.0319 7.88411 14.7351 8.56784C15.4384 9.25157 15.8335 10.1789 15.8335 11.1458V15.8333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.99984 5.83317C5.46007 5.83317 5.83317 5.46007 5.83317 4.99984C5.83317 4.5396 5.46007 4.1665 4.99984 4.1665C4.5396 4.1665 4.1665 4.5396 4.1665 4.99984C4.1665 5.46007 4.5396 5.83317 4.99984 5.83317Z" fill={color} />
    </svg>

);
